import React, { useRef, useState } from "react";
import { Select } from "antd";

import SingleSelectModal from "./SingleSelectModal";
import styles from "./mobileDropdownSelect.scss";

const MobileDropdownSelect = props => {
  const {
    value,
    valueType,
    isDisabled,
    onChange,
    placeholder,
    options,
    title
  } = props;

  const [showModal, setShowModal] = useState(false);

  const selectButtonRef = useRef();

  const showModel = () => {
    // @ts-ignore
    selectButtonRef.current.focus();
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const placeholderValue =
    value !== undefined
      ? options.find(o => o.value === value).title
      : placeholder;

  return (
    <React.Fragment>
      <SingleSelectModal
        onCancel={closeModal}
        visible={showModal}
        options={options}
        value={value}
        onChange={onChange}
        valueType={valueType}
        title={title}
      />
      {isDisabled ? (
        <Select
          className={styles.valueDisabled}
          disabled
          placeholder={placeholderValue}
          value={value}
        >
          {options.map((option, index) => (
            <Select.Option
              key={index /* eslint-disable-line */}
              value={option.value}
              style={option.style || {}}
            >
              {option.title}
            </Select.Option>
          ))}
        </Select>
      ) : (
        <div tabIndex={-1} role="button" onClick={showModel} style={{ position: "relative" }}>
          <div style={{ position: "absolute", inset: 0, zIndex: 1 }}></div>
          <Select
            ref={selectButtonRef}
            className={
              value !== undefined
                ? `${styles.value} dropdown-black-placeholder`
                : null
            }
            disabled
            placeholder={placeholderValue}
            value={value}
          >
            {options.map((option, index) => (
              <Select.Option
                key={index /* eslint-disable-line */}
                value={option.value}
                style={option.style || {}}
              >
                {option.title}
              </Select.Option>
            ))}
          </Select>
        </div>
      )}
    </React.Fragment>
  );
};

MobileDropdownSelect.defaultProps = {
  placeholder: "",
  valueType: "",
  isDisabled: false,
  title: ""
};

export default MobileDropdownSelect;



// WEBPACK FOOTER //
// ./src/components/FormControls/SingleColorSelector/MobileDropdownSelect/index.tsx